import arrow from "../../assets/arrow-up.svg";
import { useTranslation } from "react-i18next";

const BackToTop: React.FC = () => {
  const moveToSection = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const { t } = useTranslation();

  return (
    <>
      <div
        className="backToTop align-self-end d-flex justify-content-between align-items-center"
        onClick={moveToSection}
      >
        <div className="cta hover-to-change-color">{t("footer.backtotop")}</div>
        <img src={arrow} />
      </div>
    </>
  );
};
export default BackToTop;
